import React from 'react';
import { Box, Typography } from '@mui/material';
import Layout from '../components/Layout';
import AdultNextSteps from '../components/AdultNextSteps';

// /next-steps: the adult welcome email links here, so someone who registered
// without choosing anything can still tell the club what they are after.
export default function NextSteps() {
  return (
    <Layout>
      <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 640, mx: 'auto' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#1E3A5F', mb: 2 }}>Welcome to Torch</Typography>
        <AdultNextSteps />
      </Box>
    </Layout>
  );
}
